import { getUserMe, getRedirectTo } from '@/apis/user';
import { getAppConfig, getBamAppConfig } from '@/apis/config';
import service from '@/utils/api';
import { appStore } from '@/store';
import { getOpenSC } from '@/apis';
import { XBA } from '@/configs';

async function checkUser({
  app,
  redirect
}: {
  app: any;
  redirect: any;
}): Promise<void> {
  sessionStorage.removeItem('payload');
  const config = await getBamAppConfig();
  if (config && config.result && config.result.api_url) {
    appStore.SET_BASE_URL(config.result.api_url);
  } else {
    appStore.SET_BASE_URL(process.env.API_URL || '');
  }
  service.defaults.baseURL = appStore.baseUrl;

  const payload = app.$decodeJwt();
  if (!payload) {
    return;
  }
  sessionStorage.setItem('payload', JSON.stringify(payload));

  if (!payload.ba_user_unique_code) {
    const result = await getRedirectTo();
    // リダイレクト先が設定されていない場合無視
    if (result !== null && result.data.result.redirect_to) {
      // 現在のpathと同様だった場合無視
      if (result.data.result.redirect_to !== location.pathname) {
        return redirect(result.data.result.redirect_to);
      }
    }
  }

  const user = await getUserMe();
  if (!user || !user.result) {
    // 未ログイン
    localStorage.removeItem('auth._token.bamidp'); // BAX-3117 特定の条件でTOPに遷移しようとするとログイン画面に遷移してしまう不具合の応急処置
    return sessionStorage.clear();
  }

  // ポータル企業の場合はアップグレードページに遷移
  if (user.result.user.company_type === 'baportal') {
    const baConfig = await getAppConfig();
    if (baConfig && baConfig.result) {
      // cookieを削除
      document.cookie = `${baConfig.result.config.post_login_redirect_uri_cookie_name}=; max-age=0; domain=${baConfig.result.config.post_login_redirect_uri_cookie_domain}`;
      switch (baConfig.result.config.name) {
        case XBA.HGBA.SYSTEM_CODE:
          return redirect('/register/hgba');
        default:
          return redirect('/register/ba');
      }
    }
    self.$nuxt.context.error({
      statusCode: 401,
      message: '認証エラー'
    });
    return;
  }

  // クッキーからba_login_redirect_uriがあった場合飛ばす
  let baLoginRedirectUri = null;
  const cookies = document.cookie;
  if (cookies.length > 0) {
    const baConfig = await getAppConfig();
    if (baConfig && baConfig.result) {
      const tmpBaLoginRedirectUri = cookies
        .split(';')
        .find((element) =>
          element.includes(
            baConfig.result.config.post_login_redirect_uri_cookie_name
          )
        );

      if (tmpBaLoginRedirectUri) {
        const tmp = tmpBaLoginRedirectUri.split('=');
        if (tmp.length > 0) {
          baLoginRedirectUri = decodeURIComponent(tmp[1]);
          document.cookie = `${baConfig.result.config.post_login_redirect_uri_cookie_name}=; max-age=0; domain=${baConfig.result.config.post_login_redirect_uri_cookie_domain}`;
        }
      }
    }

    if (baLoginRedirectUri) {
      location.href = baLoginRedirectUri;
      return;
    }
  }

  if (user.result.user.user_type_group === 'bank') {
    return redirect('/admin/dashboard');
  }

  // 企業画面 安否確認中かつ未回答の場合は安否確認画面に遷移する
  const opensSC = await getOpenSC();
  if (opensSC && opensSC.result && opensSC.result.survey && !opensSC.result.survey.sr_id) {
    return redirect('/mypage/sc');
  }

  // 企業画面 企業ダッシュボード
  redirect('/mypage/dashboard');
}

export default checkUser;
